var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "py-2" }, [
      _c("div", { staticClass: "row mx-2 py-4 px-3 bg-white rounded" }, [
        _vm._m(0),
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _vm.history.length === 0 ? _c("custom-result-not-found") : _vm._e(),
            _vm._l(_vm.history, function(item, idx) {
              return _c(
                "div",
                { key: idx },
                [
                  _c(
                    "timeline-item",
                    { key: idx, attrs: { date: item.date } },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-12 col-lg-6 font-weight-bold" },
                          [
                            _vm._v(
                              " Enmienda " +
                                _vm._s(
                                  _vm.padleft(_vm.history.length - idx, 2)
                                ) +
                                " "
                            )
                          ]
                        ),
                        _c("div", { staticClass: "col-12 col-lg-6" }, [
                          _c(
                            "div",
                            { staticClass: "color-secondary-6 font-14" },
                            [_vm._v(" Añadido Por: ")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "font-weight-normal color-black font-16"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm._f("empty")(item?.createdBy)) +
                                  " "
                              )
                            ]
                          )
                        ])
                      ]),
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "div",
                            { staticClass: "color-secondary-6 font-14" },
                            [_vm._v(" Comentario: ")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "font-weight-normal color-black font-16"
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm._f("empty")(item?.comment)) +
                                  " "
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                ],
                1
              )
            }),
            _c("div", { staticClass: "row my-4" }, [
              _c(
                "div",
                { staticClass: "col text-center" },
                [
                  _vm.showMore
                    ? _c(
                        "action-button",
                        {
                          attrs: {
                            i: "fas fa-chevron-down",
                            variant:
                              "outline-success custom-view-more actionButton"
                          },
                          on: { click: _vm.handlerMore }
                        },
                        [_vm._v(" Ver más ")]
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 mb-3" }, [
      _c("em", { staticClass: "fas fa-history text-orange mr-2" }),
      _c("span", { staticClass: "font-weight-bold" }, [
        _vm._v("Historial de Enmiendas")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }